var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12", md: "10" },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "el-def",
                      attrs: { placeholder: "타겟그룹 이름" },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.refetchData()
                        },
                      },
                      model: {
                        value: _vm.filterStr,
                        callback: function ($$v) {
                          _vm.filterStr = $$v
                        },
                        expression: "filterStr",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-search",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.refetchData()
                          },
                        },
                      },
                      [_vm._v(" 조회 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "div",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(
                          " 타겟그룹 리스트 [" +
                            _vm._s(_vm.totalRecords) +
                            "] 건 "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.targetGroupList,
              fields: _vm.tableColumns,
              responsive: "",
              "sticky-header": "",
              selectable: "",
              "select-mode": "single",
            },
            on: { "row-selected": _vm.onRowSelected },
          }),
        ],
        1
      ),
      _c("b-card", { attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start",
                    attrs: { cols: "12", md: "6" },
                  },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "EditIcon", size: "19" },
                    }),
                    _c("h4", { staticClass: "mb-0 ml-50" }, [_vm._v(" 상세 ")]),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "6" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-1",
                        attrs: {
                          variant: "outline-secondary",
                          disabled:
                            !_vm.targetGroupData.id ||
                            _vm.targetGroupEtcData.copyDisabled,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.copyTargetGroup($event)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "CopyIcon" },
                        }),
                        _c("span", [_vm._v("타겟그룹 복사")]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.resetTargetGroup($event)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "PlusSquareIcon" },
                        }),
                        _c("span", [_vm._v("신규")]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { disabled: _vm.isSaving, variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.saveTargetGroup($event)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "SaveIcon" },
                        }),
                        _c("span", [_vm._v("저장")]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "outline-secondary" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.removeTargetGroup($event)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "Trash2Icon" },
                        }),
                        _c("span", [_vm._v("삭제")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "validation-observer",
              { ref: "formRules" },
              [
                _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "이름",
                              "label-for": "targetGroupTitle",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "이름", rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "targetGroupTitle",
                                          state:
                                            errors.length > 0 ? false : null,
                                        },
                                        model: {
                                          value:
                                            _vm.targetGroupData
                                              .targetGroupTitle,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.targetGroupData,
                                              "targetGroupTitle",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "targetGroupData.targetGroupTitle",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "설정된 타겟 조건",
                              "label-for": "targetConditions",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "타겟 조건", rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-input", {
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          id: "activeFilterTypesHidden",
                                          value:
                                            _vm.activeFilterTypes.length > 0
                                              ? "valid"
                                              : "",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { attrs: { id: "targetConditions" } },
                                        [
                                          _vm.activeFilterTypes.length === 0
                                            ? _c(
                                                "div",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v(
                                                    " 설정된 타겟 조건이 없습니다. "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-wrap",
                                                },
                                                _vm._l(
                                                  _vm.activeFilterTypes,
                                                  function (filterType) {
                                                    return _c(
                                                      "b-badge",
                                                      {
                                                        key: filterType,
                                                        staticClass:
                                                          "mr-1 mb-1",
                                                        attrs: {
                                                          variant: "light-dark",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getFilterName(
                                                                filterType
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                        ]
                                      ),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                errors[0]
                                                  ? "[타겟 조건]는(은) 필수 입력입니다. 타겟 조건 중 1개 이상 설정해 주세요."
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [
                    _vm._v(" 타겟 인원 "),
                    _c(
                      "b-badge",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.right.html",
                            modifiers: { hover: true, right: true, html: true },
                          },
                        ],
                        staticStyle: { padding: "0px", "margin-left": "5px" },
                        attrs: {
                          variant: "light-secondary",
                          title:
                            "<ul style='text-align: left; padding-left: 1rem; margin: 0;'>\n                        <li>진료과/지역/처방제외/간편처방 제외조건/컨텐츠 미열람/팝업 미노출/설문 미완료만 설정할 경우, 최근 1개월간 닥터인포를 실행한 인원을 전체 사용자로 타겟을 산정합니다.</li>\n                        <li>그 외 조건과 함께 설정할 경우, 해당 조건으로 추려진 인원에 진료과/지역/처방제외/간편처방 제외조건/컨텐츠 미열람/팝업 미노출/설문 미완료 인원이 필터링되어 타겟을 산정합니다.</li>\n                      </ul>",
                        },
                      },
                      [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                  _vm.targetGroupEtcData.isBeforeReleaseDate2nd
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-primary",
                                disabled:
                                  _vm.targetGroupEtcData.targetCountInfo
                                    .isLoading || !!_vm.targetGroupData.id,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.getTargetCount($event)
                                },
                              },
                            },
                            [_c("span", [_vm._v("타겟 인원 조회")])]
                          ),
                          _c(
                            "div",
                            { staticClass: "ml-3 align-items-center" },
                            [
                              _vm.targetGroupEtcData.targetCountInfo.isLoading
                                ? _c("b-spinner", {
                                    staticClass: "mr-50",
                                    attrs: { small: "" },
                                  })
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-primary font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("$numberFormatter")(
                                            _vm.targetGroupEtcData
                                              .targetCountInfo.count
                                          )
                                        ) + "명 포함"
                                      ),
                                    ]
                                  ),
                              _c(
                                "span",
                                {
                                  class: [
                                    "ml-1 text-link",
                                    _vm.targetGroupEtcData.targetCountInfo
                                      .count > 0
                                      ? "text-primary"
                                      : "text-muted",
                                  ],
                                  style: {
                                    textDecoration: "underline",
                                    pointerEvents:
                                      _vm.targetGroupEtcData.targetCountInfo
                                        .count > 0
                                        ? "auto"
                                        : "none",
                                  },
                                  on: { click: _vm.showTargetCountDetailModal },
                                },
                                [_vm._v(" 상세보기 ")]
                              ),
                              _c("target-count-detail", {
                                attrs: {
                                  "show-target-count-detail":
                                    _vm.targetGroupEtcData.targetCountInfo
                                      .showTargetCountDetail,
                                  data: _vm.targetGroupEtcData.targetCountInfo
                                    .targetCountDetailList,
                                  "total-target-count":
                                    _vm.targetGroupEtcData.targetCountInfo
                                      .count,
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.targetGroupEtcData.targetCountInfo.showTargetCountDetail = false
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _c("span", [
                          _vm._v(
                            "타겟그룹 업데이트로 " +
                              _vm._s(_vm.ReleaseDate2nd) +
                              " 이전의 타겟인원 상세보기는 제공되지 않습니다."
                          ),
                        ]),
                      ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        [
          _c(
            "validation-observer",
            { ref: "departmentRules" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "200px" },
                        },
                        [_vm._v(" 진료과 타겟 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          staticStyle: { "min-width": "120px" },
                          attrs: {
                            disabled: !!_vm.targetGroupData.id,
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.filterToggleStates.department,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.filterToggleStates,
                                "department",
                                $$v
                              )
                            },
                            expression: "filterToggleStates.department",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.filterToggleStates.department
                                  ? "사용"
                                  : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.filterToggleStates.department
                    ? _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                { attrs: { for: "seminar-cond-dept" } },
                                [_vm._v("진료과")]
                              ),
                              _c("validation-provider", {
                                attrs: { name: "진료과", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "seminar-cond-dept",
                                              readonly: "",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              disabled:
                                                !!_vm.targetGroupData.id,
                                            },
                                            model: {
                                              value: _vm.record.condDeptNames,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.record,
                                                  "condDeptNames",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "record.condDeptNames",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  971044398
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.filterToggleStates.department
                    ? _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-0 mt-md-2",
                              attrs: {
                                variant: "outline-primary",
                                disabled: !!_vm.targetGroupData.id,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.showMediDeptSelect = true
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusSquareIcon" },
                              }),
                              _c("span", [_vm._v("진료과 선택")]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "validation-observer",
            { ref: "regionRules" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "200px" },
                        },
                        [_vm._v(" 지역 타겟 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          staticStyle: { "min-width": "120px" },
                          attrs: {
                            disabled: !!_vm.targetGroupData.id,
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.filterToggleStates.region,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterToggleStates, "region", $$v)
                            },
                            expression: "filterToggleStates.region",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.filterToggleStates.region
                                  ? "사용"
                                  : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.filterToggleStates.region
                    ? _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "seminar-cond-region" } },
                                    [_vm._v("지역")]
                                  ),
                                  _c("validation-provider", {
                                    attrs: { name: "지역", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "seminar-cond-region",
                                                  readonly: "",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                  disabled:
                                                    !!_vm.targetGroupData.id,
                                                },
                                                model: {
                                                  value:
                                                    _vm.record.condRegionNames,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.record,
                                                      "condRegionNames",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "record.condRegionNames",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      608964398
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.filterToggleStates.region
                    ? _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-0 mt-md-2",
                              attrs: {
                                variant: "outline-primary",
                                disabled: !!_vm.targetGroupData.id,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.showRegionSelect = true
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusSquareIcon" },
                              }),
                              _c("span", [_vm._v("지역 선택")]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "200px" },
                    },
                    [_vm._v(" 처방(라이브 DI) 타겟 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: {
                        disabled: !!_vm.targetGroupData.id,
                        switch: "",
                        inline: "",
                      },
                      model: {
                        value: _vm.filterToggleStates.liveDi,
                        callback: function ($$v) {
                          _vm.$set(_vm.filterToggleStates, "liveDi", $$v)
                        },
                        expression: "filterToggleStates.liveDi",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.filterToggleStates.liveDi ? "사용" : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("target-group-livedi-filter", {
            attrs: {
              "target-group-data": _vm.targetGroupData,
              codes: _vm.codes,
              "is-readonly": !!_vm.targetGroupData.id,
              "filter-type": _vm.liveDiTypeCode,
              "live-di-toggle-state": _vm.filterToggleStates.liveDi,
            },
          }),
          !_vm.hasValidFilters.liveDi && _vm.filterToggleStates.liveDi
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(" [처방 포함] 또는 [처방 제외]는(은) 필수 입력입니다. "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "200px" },
                    },
                    [_vm._v(" 활동 타겟 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: {
                        disabled: !!_vm.targetGroupData.id,
                        switch: "",
                        inline: "",
                      },
                      model: {
                        value: _vm.filterToggleStates.activity,
                        callback: function ($$v) {
                          _vm.$set(_vm.filterToggleStates, "activity", $$v)
                        },
                        expression: "filterToggleStates.activity",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.filterToggleStates.activity
                              ? "사용"
                              : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("target-group-activity-filter", {
            attrs: {
              "target-group-data": _vm.targetGroupData,
              codes: _vm.codes,
              "is-readonly": !!_vm.targetGroupData.id,
              "filter-type": _vm.activityTypeCode,
              "activity-toggle-state": _vm.filterToggleStates.activity,
            },
            on: {
              "valid-change": function (validChanged) {
                _vm.activityFilterValidFlag = validChanged
              },
            },
          }),
          !_vm.hasValidFilters.activity && _vm.filterToggleStates.activity
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(" [활동]는(은) 필수 입력입니다. "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "validation-observer",
            { ref: "interestContentRules" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "200px" },
                        },
                        [_vm._v(" 관심 컨텐츠 유형 타겟 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          staticStyle: { "min-width": "120px" },
                          attrs: {
                            disabled: !!_vm.targetGroupData.id,
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.filterToggleStates.interestContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.filterToggleStates,
                                "interestContent",
                                $$v
                              )
                            },
                            expression: "filterToggleStates.interestContent",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.filterToggleStates.interestContent
                                  ? "사용"
                                  : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.filterToggleStates.interestContent
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                { attrs: { for: "interest-content-names" } },
                                [_vm._v("관심 컨텐츠 유형")]
                              ),
                              _c("validation-provider", {
                                attrs: {
                                  name: "관심 컨텐츠 유형",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "interest-content-names",
                                              readonly: "",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              disabled:
                                                !!_vm.targetGroupData.id,
                                            },
                                            model: {
                                              value:
                                                _vm.record.interestContentNames,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.record,
                                                  "interestContentNames",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "record.interestContentNames",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2373052373
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-0 mt-md-2",
                              attrs: {
                                variant: "outline-primary",
                                disabled: !!_vm.targetGroupData.id,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.showInterestContentSelect = true
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusSquareIcon" },
                              }),
                              _c("span", [_vm._v("유형 선택")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.filterToggleStates.interestContent
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                {
                                  attrs: { for: "interest-content-start-date" },
                                },
                                [
                                  _vm._v(" 타겟 추출 기준일(Fr) "),
                                  _c(
                                    "b-badge",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.right.html",
                                          modifiers: {
                                            hover: true,
                                            right: true,
                                            html: true,
                                          },
                                        },
                                      ],
                                      staticStyle: {
                                        padding: "0px",
                                        "margin-left": "5px",
                                      },
                                      attrs: {
                                        variant: "light-secondary",
                                        title:
                                          "기준일 이후 해당 컨텐츠 유형에 관심을 보인(조회/투표) 사용자를 타겟그룹에 포함합니다.",
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "InfoIcon" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("validation-provider", {
                                attrs: {
                                  name: "타겟 추출 기준일(Fr)",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-datepicker", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              id: "interest-content-start-date",
                                              placeholder:
                                                "타겟 추출 기준일(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              disabled:
                                                !!_vm.targetGroupData.id,
                                              max: _vm.yesterdayDate,
                                            },
                                            model: {
                                              value:
                                                _vm.record
                                                  .interestContentStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.record,
                                                  "interestContentStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "record.interestContentStartDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  722830024
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.hasValidFilters.interestContent &&
              _vm.filterToggleStates.interestContent
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(" [관심 컨텐츠 유형]는(은) 필수 입력입니다. "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "200px" },
                    },
                    [_vm._v(" 설문 응답 타겟 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: {
                        disabled: !!_vm.targetGroupData.id,
                        switch: "",
                        inline: "",
                      },
                      model: {
                        value: _vm.filterToggleStates.surveyAnswer,
                        callback: function ($$v) {
                          _vm.$set(_vm.filterToggleStates, "surveyAnswer", $$v)
                        },
                        expression: "filterToggleStates.surveyAnswer",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.filterToggleStates.surveyAnswer
                              ? "사용"
                              : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("target-group-survey-answer-filter", {
            attrs: {
              "target-group-data": _vm.targetGroupData,
              codes: _vm.codes,
              "is-readonly": !!_vm.targetGroupData.id,
              "filter-type": _vm.surveyAnswerTypeCode,
              "survey-answer-toggle-state": _vm.filterToggleStates.surveyAnswer,
            },
          }),
          !_vm.hasValidFilters.surveyAnswer &&
          _vm.filterToggleStates.surveyAnswer
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(" [설문응답]는(은) 필수 입력입니다. "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "200px" },
                    },
                    [_vm._v(" 간편처방 타겟 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: {
                        disabled: !!_vm.targetGroupData.id,
                        switch: "",
                        inline: "",
                      },
                      model: {
                        value: _vm.filterToggleStates.drugLanding,
                        callback: function ($$v) {
                          _vm.$set(_vm.filterToggleStates, "drugLanding", $$v)
                        },
                        expression: "filterToggleStates.drugLanding",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.filterToggleStates.drugLanding
                              ? "사용"
                              : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.filterToggleStates.drugLanding
            ? _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("p", { staticClass: "text-muted ml-50 mt-50 mb-0" }, [
                      _vm._v(
                        " 의사랑의 간편처방 등록 이력을 기반으로 특정 약품의 등록 여부로 사용자를 분류합니다. "
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c("target-group-drug-landing-filter", {
            attrs: {
              "target-group-data": _vm.targetGroupData,
              codes: _vm.codes,
              "is-readonly": !!_vm.targetGroupData.id,
              "filter-type": _vm.drugLandingTypeCode,
              "drug-landing-toggle-state": _vm.filterToggleStates.drugLanding,
            },
          }),
          !_vm.hasValidFilters.drugLanding && _vm.filterToggleStates.drugLanding
            ? _c("small", { staticClass: "text-danger" }, [
                _vm._v(" [간편처방]는(은) 필수 입력입니다. "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("medi-dept-select", {
        attrs: {
          "show-medi-dept-select": _vm.showMediDeptSelect,
          "selected-value": _vm.record.condDeptCodes,
          "is-block-all": true,
        },
        on: { close: _vm.mediDeptSelect.close },
      }),
      _c("region-select", {
        attrs: {
          "show-region-select": _vm.showRegionSelect,
          "selected-value": _vm.record.condRegionCodes,
          "is-block-all": true,
        },
        on: { close: _vm.regionSelect.close },
      }),
      _c("interst-content-multi-select", {
        attrs: {
          "show-interest-content-select": _vm.showInterestContentSelect,
          "selected-value": _vm.record.interestContentCodes,
        },
        on: { close: _vm.interestContentSelect.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }